import config from '../configs/config';
import { parse, extract } from 'query-string';
import { getTargetedProduct } from '@product/js/utils/utils';

/**
 * Get max slides per view for pdp slider display
 */
export function getMaxSlideCountForSliderView() {
    return window.innerWidth > config.pdpSlider.desktopWidth ? config.pdpSlider.maxSlidesForDesktop : config.pdpSlider.maxSlidesForMobile;
}

/**
 * Check to display pdp slider controls
 * @param {String} context selector string
 * @param {int} maxSlidesForSliderView max slide count
 */
export function showSliderPagination(context, maxSlidesForSliderView) {
    return $(context.scopedSelector('.o-slider-thumbnails__inner')).children().length > maxSlidesForSliderView;
}

/**
 * Get max slides per view for slider
 * @param {String} context selector string
 */
export function getMaxSlidesPerView(context) {
    const maxSlidesForSliderView = getMaxSlideCountForSliderView();
    return showSliderPagination(context, maxSlidesForSliderView) ? (maxSlidesForSliderView - 1) : maxSlidesForSliderView;
}

/**
 * control hiding/showing of slider arrows
 * @param {String} context selector string
 * @param {int} maxSlidesForSliderView max slide count
 * @param {Object} sliderDetails slider details object
 */
export function conditionallyDisplaySliderArrows(maxSlidesForSliderView, sliderDetails) {
    let sliderWrapper = sliderDetails.sliderWrapper;
    let slideCount = sliderDetails.slideCount;
    sliderWrapper.toggleClass('s-slider-thumbnails--has-arrows', slideCount > maxSlidesForSliderView);
}

/**
 * control add class for show max images on slider
 * @param {String} context selector string
 */
export function conditionallyAddMaxImagesClass(context) {
	const slideCount = $(context.scopedSelector('.js-slider--product-image')).find('.js-slider__slide').length;
    const windowWiderThanDesktopWidth = (window.innerWidth > config.pdpSlider.desktopWidth);
    const numberOfSlidesIsMaxSlidesForDesktop = (slideCount === config.pdpSlider.maxSlidesForDesktop);

	if (windowWiderThanDesktopWidth && numberOfSlidesIsMaxSlidesForDesktop) {
		$(context.scopedSelector('.js-slider--product-image')).addClass('swiper-show-max-images');
	} else {
        $(context.scopedSelector('.js-slider--product-image')).removeClass('swiper-show-max-images');
    }
}

/**
 * Detach swiper events
 */
export function detachSwiperEvents() {
    $.each($('.js-modal-product-image-zoom-fix'), (idx, e) => {
        if (!e.swiper) {
            return;
        }
        e.swiper.detachEvents();
    });
}

/**
 * Attach swiper events
 */
export function attachSwiperEvents() {
    $.each($('.js-modal-product-image-zoom-fix'), (idx, e) => {
        if (!e.swiper) {
            return;
        }
        e.swiper.attachEvents();
        e.swiper.update(true);
    });
}

/**
 * control adding disabled attribute on swiper transition
 * @param {Object} swiper swiper instance
 * @param {String} previousButton previous button selector
 * @param {String} nextButton next button selector
 */
export function handleSwiperTransitionStates(swiper, previousButton, nextButton) {
    if (swiper.isBeginning) {
        $(previousButton).prop('disabled', true);
    }
    if (swiper.isEnd) {
        $(nextButton).prop('disabled', true);
    }
}

export function getInitialSlide() {
    const state = this.store.getState();
    const product = getTargetedProduct(state);
    const viewCode = _.get(product, 'productMeta.viewcode');
    let initialSlideIndex = 0;

    if (viewCode) {
        const matchingViewCodeElement = $(this.scopedSelector('.js-slider--product-image'))
                                            .find(`[data-image-viewcode='${viewCode}']`);
        const indexStr = $(matchingViewCodeElement).attr('data-thumb-index');

        if (indexStr) {
            initialSlideIndex = parseInt(indexStr, 10);
        }
    }

    return initialSlideIndex;
}
